import { OrderData } from '../api';

export const orderUsesDeposit = (order: OrderData | undefined): boolean => (order?.deposit_price ?? 0) > 0;
